<template>
  <div class="reset-step-one">
    <div class="sub-header-login">
      <p>Please enter your otp code.</p>
    </div>
    <ValidationObserver
      id="verifyOtp"
      ref="observerVerify"
      autocomplete="off"
      tag="form"
      role="form"
      @submit.prevent="submit"
    >
      <div class="otp-form-wrapper">
        <input
          v-model="otp.key1"
          required
          maxlength="1"
          type="number"
          @keyup="inputFired($event)"
        />
        <input
          v-model="otp.key2"
          required
          maxlength="1"
          type="number"
          @keyup="inputFired($event)"
        />
        <input
          v-model="otp.key3"
          required
          maxlength="1"
          type="number"
          @keyup="inputFired($event)"
        />
        <input
          v-model="otp.key4"
          required
          maxlength="1"
          type="number"
          @keyup="inputFired($event)"
        />
        <input
          v-model="otp.key5"
          required
          maxlength="1"
          type="number"
       
        />
      </div>
      
      <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="newPassword"
                    rules="required"
                  >
                    <v-text-field
                      v-model="resetForm.newPassword"
                      ref="newPassword"
                      name="newPassword"
                      height="45px"
                      label="New Password"
                       prepend-inner-icon="mdi-shield-lock"
                       :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      @click:append="show1 = !show1"
                      counter
                    />
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="input-wrapper"
                    v-slot="{ errors }"
                    name="confirmPassword"
                    rules="required|confirmed:newPassword"
                    data-vv-as="newPassword"
                  >
                    <v-text-field
                      v-model="resetForm.confirmNewPassword"
                      height="45px"
                      ref="password"
                      prepend-inner-icon="mdi-shield-lock"
                      name="confirmPassword"
                       label="Confirm Password"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show2 ? 'text' : 'password'"
                      @click:append="show2 = !show2"
                    />
                    <span class="error-message">{{ errors[0] }}</span>
                  </ValidationProvider>
      <div class="form-group text-center m-t-20">
        <div class="container-login100-form-btn">
          <v-btn
            height="42px"
            width="100%"
            rounded
            padding="0 10px"
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="loading"
          >
            Submit
            <v-icon right dark>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <div class="forgot-pwd">
            <a @click.prevent="login"
              >Login</a
            >
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
export default {
  name: "VerifyOtp",
  data() {
    return {
      userName: "",
      loading: false,
      otp: {
        key1: "",
        key2: "",
        key3: "",
        key4: "",
        key5: ""
      },
      show1: false,
      show2: false,
      resetForm: {
        newPassword: '',
        confirmNewPassword: '',
        uniqueId: ''
      }
    };
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    resetLoading() {
      this.loading = false;
    },
    async submit() {
       const valid = await this.$refs.observerVerify.validate();       
        if (valid) {
          this.loading = true;
          let otpKey = `${this.otp.key1}${this.otp.key2}${this.otp.key3}${this.otp.key4}${this.otp.key5}`
          this.$emit('resetPassword',{userData:this.resetForm, otp: otpKey})
        }
    },
     inputFired(event) {
      if (event.target.value != "") {
        event.target.nextElementSibling.focus();
      }
    },
  }
};
</script>
